import { createSelector } from '@reduxjs/toolkit';
import { eventOccurrencesNotDeleted } from '../events/event-occurrences-not-deleted';
import { weekStart } from './week-start';
import { todoListHideAfterDaysOption } from '../todo-list';
import { now } from '../organization/now';
import { LocalDate } from '../../../utilities/local-date';

export const currentWeekTodoEventOccurrences = createSelector(
  eventOccurrencesNotDeleted,
  weekStart,
  todoListHideAfterDaysOption,
  now,
  (occurrences, weekStart, hideAfterDays, t) => {
    const startDate = LocalDate.fromString(weekStart);
    const endDate = startDate.plusDays(6);
    const excludeDoneTasksBefore = t.minusDays(hideAfterDays);

    return occurrences.filter((e) => {
      if (e.date !== null || e.doneDate === null) return false;
      const d = LocalDate.fromString(e.doneDate);

      return d.inRange(startDate, endDate) && LocalDate.fromString(e.doneDate).isSameOrBefore(excludeDoneTasksBefore);
    });
  },
);
